import CButton from "./button";
export default CButton;
